import SwitchToLegacy from "../../components/SwitchToLegacy";

export default function AdminHome() {
	return (
		<div>
			<p>This is the admin home page. The instructional text above will change.</p>
			<SwitchToLegacy link="/Home/AdminHome" />
		</div>
	);
}
